import React from 'react';

import AssistanceBanner from '../../components/AssistanceBanner/AssistanceBanner';
import CarouselWithBg from '../../components/CarouselWithBg/CarouselWithBg';
import FormSection from '../../components/FormSection';
import GridBlocks from '../../components/GridBlocks';
import Hero from '../../components/Hero/Hero';
import Footer from '../../components/shared/Footer';
import Header from '../../components/shared/Header';
import StepsWithMiddleLine from '../../components/StepsWithMiddleLine';
import TechnologyBehind from '../../components/TechnologyBehind';
import UseCases from '../../components/UseCases';

function Main() {
  return (
    <div className="main w-full bg-black font-OpenSans font-medium" id="home">
      <Header />
      <Hero />
      <div id="use-cases">
        <UseCases />
        <CarouselWithBg />
      </div>
      <TechnologyBehind id="technology-behind" />
      <div id="how-to-use">
        <GridBlocks id="benefits" />
        <StepsWithMiddleLine id="try-it-out" />
      </div>
      <AssistanceBanner />
      <FormSection />
      <Footer />
    </div>
  );
}

export default Main;
